var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavPointOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6453 8.04688H9.42793C9.26224 8.04688 9.12793 8.18119 9.12793 8.34688V17.2C9.12793 17.3657 9.26224 17.5 9.42793 17.5H10.6984C10.8643 17.5 10.9988 17.3653 10.9984 17.1994L10.9929 14.4128C10.9925 14.2469 11.127 14.1122 11.2929 14.1122H12.6018C13.2813 14.1122 13.8654 13.9859 14.3543 13.7331C14.8473 13.4763 15.2223 13.122 15.4791 12.6705C15.7401 12.2147 15.8706 11.6865 15.8706 11.0858C15.8706 10.4892 15.7443 9.96094 15.4916 9.50107C15.2388 9.04119 14.868 8.6849 14.3792 8.43217C13.8944 8.17531 13.3165 8.04688 12.6453 8.04688Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3097 12.6085H10.9922V9.58203H12.3034C12.668 9.58203 12.9725 9.64418 13.217 9.76847C13.4656 9.88861 13.6499 10.0626 13.7701 10.2905C13.8902 10.5142 13.9503 10.7794 13.9503 11.0859C13.9503 11.3925 13.8902 11.6597 13.7701 11.8876C13.6499 12.1155 13.4656 12.2936 13.217 12.4221C12.9725 12.5463 12.6701 12.6085 12.3097 12.6085Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPointOff);
export default __webpack_public_path__ + "static/media/nav_point_off.13b6f24e7b4a32161fa4c362626e4a79.svg";
export { ForwardRef as ReactComponent };